import { Grid } from '@mui/material';
import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { onboardEntAccActions } from '../../../../../slice';
import OnboardExpertsModalForm from '../experts-form';
import { selectExpertsToInvite } from '../../../../../selector';

const OnboardExpertsModalView = () => {
  const dispatch = useDispatch();
  const experts = useSelector(selectExpertsToInvite);

  const onSubmit = useCallback(() => {
    dispatch(onboardEntAccActions.inviteExperts(experts));
    dispatch(onboardEntAccActions.isOnboarding());
  }, [dispatch, experts]);

  const methods = useForm<any>({
    defaultValues: {},
    shouldFocusError: true,
  });
  return (
    <Grid container justifyContent="center">
      <Grid xs item>
        <FormProvider {...methods}>
          <OnboardExpertsModalForm onSubmit={onSubmit} />
        </FormProvider>
      </Grid>
    </Grid>
  );
};

export default OnboardExpertsModalView;
